import React, { FC, ReactNode } from 'react';
import { CloseModal } from './Icons/CloseModal';
import { Delete } from './Icons/Delete';
import { Edit } from './Icons/Edit';
import { Download } from './Icons/Download';
import { Back } from './Icons/Back';
import { ArrowLeft } from './Icons/ArrowLeft';
import { ArrowRight } from './Icons/ArrowRight';
import { EditInformationBlock } from './Icons/EditInformationBlock';
import { ArchiveInformationBlock } from './Icons/ArchiveInformationBlock';
import { UnArchiveInformationBlock } from './Icons/UnArchiveInformationBlock';
import { DeleteInformationBlock } from './Icons/DeleteInformationBlock';
import { Plus } from './Icons/Plus';
import { Search } from './Icons/Search';
import { Location } from './Icons/Location';
import { DownloadDocument } from './Icons/DownloadDocument';
import { DraftEstimateCircle } from './Icons/DraftEstimateCircle';
import { ActiveEstimateCircle } from './Icons/ActiveEstimateCircle';
import { WhitePlus } from './Icons/WhitePlus';
import { DeleteImage } from './Icons/DeleteImage';
import { Profile } from './Icons/Profile';
import { TabError } from './Icons/TabError';
import { Question } from './Icons/Question';
import { Attention } from './Icons/Attention';
import { Circle } from './Icons/Circle';
import { DownloadReconciliation } from './Icons/DownloadReconciliation';
import { DeleteCard } from './Icons/DeleteCard';
import { ManagerIcon } from './Icons/ManagerIcon';
import { ForemanIcon } from './Icons/ForemanIcon';
import { PurchaserIcon } from './Icons/PurchaserIcon';
import { ProfileBigSize } from './Icons/ProfileBigSize';
import { SmetterLogo } from './Icons/SmetterLogo';
import { Delivery } from './Icons/Delivery';
import { Estimate } from './Icons/Estimate';
import { Payment } from './Icons/Payment';
import { Materials } from './Icons/Materials';
import { Work } from './Icons/Work';
import { SelectArrow } from './Icons/SelectArrow';
import { NavigationPrev } from './Icons/NavigationPrev';
import { NavigationNext } from './Icons/NavigationNext';
import { IconExecutor } from './Icons/IconExecuter';
import { IconWatcher } from './Icons/IconWatcher';
import { EditTask } from './Icons/EditTask';
import { TaskCalendar } from './Icons/TaskCalendar';
import { TaskWatch } from './Icons/TaskWatch';
import { TaskDelete } from './Icons/TaskDelete';
import { TaskExecutor } from '../../../shared/ui/Icon/Icons/TaskExecutor';

interface IconProps {
    iconName?: string;
    fill?: string;
    color?: string;
}

export const Icon: FC<IconProps> = ({ iconName, fill, color }) => {
    if (!iconName) return null;

    const iconMapping: Record<string, ReactNode> = {
        delete: <Delete />,
        deleteImage: <DeleteImage />,
        edit: <Edit />,
        download: <Download />,
        back: <Back />,
        arrowLeft: <ArrowLeft />,
        arrowRight: <ArrowRight />,
        editInformationBlock: <EditInformationBlock />,
        archiveInformationBlock: <ArchiveInformationBlock />,
        unArchiveInformationBlock: <UnArchiveInformationBlock />,
        deleteInformationBlock: <DeleteInformationBlock />,
        closeModal: <CloseModal />,
        plus: <Plus color={color} />,
        search: <Search />,
        location: <Location />,
        downloadDocument: <DownloadDocument />,
        draftEstimateCircle: <DraftEstimateCircle />,
        activeEstimateCircle: <ActiveEstimateCircle />,
        question: <Question />,
        attention: <Attention />,
        circle: <Circle fill={fill} />,
        profile: <Profile />,
        tabError: <TabError />,
        downloadReconciliation: <DownloadReconciliation />,
        whitePlus: <WhitePlus />,
        deleteCard: <DeleteCard />,
        managerIcon: <ManagerIcon />,
        foremanIcon: <ForemanIcon />,
        purchaserIcon: <PurchaserIcon />,
        profileBigSize: <ProfileBigSize />,
        smetterLogo: <SmetterLogo />,
        delivery: <Delivery />,
        estimate: <Estimate />,
        payment: <Payment />,
        materials: <Materials />,
        work: <Work />,
        selectArrow: <SelectArrow />,
        navigationPrev: <NavigationPrev />,
        navigationNext: <NavigationNext />,
        executor: <IconExecutor />,
        watcher: <IconWatcher />,
        taskWatch: <TaskWatch />,
        taskEdit: <EditTask />,
        taskCalendar: <TaskCalendar />,
        taskDelete: <TaskDelete />,
        taskExecutor: <TaskExecutor fill={fill} />,
    };
    return iconMapping[iconName] ? iconMapping[iconName] : <div />;
};
